import config from 'Config';

type SupportedLanguages = {
  [key: string]: string;
};

export const supportedLanguagesAsArray = Object.entries(
  config.supportedLanguages as SupportedLanguages
).map(([key, value]) => ({
  label: value,
  value: key,
}));
